import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faRocket, faClock } from '@fortawesome/free-solid-svg-icons';
import './managecampaigns.css';

function ComingSoon({ campaignType }) {
  const getCampaignInfo = (type) => {
    switch (type) {
      case 'broadcast':
        return {
          title: 'Broadcast Campaign',
          description: 'Select and filter among your existing audience & Broadcast customized Template or Regular messages.',
          icon: faRocket,
          features: [
            'Filter existing audience by various criteria',
            'Send customized template messages',
            'Schedule campaigns for optimal timing',
            'Track delivery and engagement metrics'
          ]
        };
      case 'api':
        return {
          title: 'API Campaign',
          description: 'Select a template and connect your existing systems with our API to automate messages.',
          icon: faRocket,
          features: [
            'RESTful API integration',
            'Automated message sending',
            'Webhook support for real-time updates',
            'Custom template integration'
          ]
        };
      case 'meta':
        return {
          title: 'Meta Ads',
          description: 'Target Click To WhatsApp Ads to your Facebook & Instagram audience to generate leads for retargeting.',
          icon: faRocket,
          features: [
            'Facebook & Instagram ad integration',
            'Click-to-WhatsApp ad campaigns',
            'Lead generation and retargeting',
            'Advanced audience targeting'
          ]
        };
      default:
        return {
          title: 'Campaign Feature',
          description: 'This exciting new feature is coming soon!',
          icon: faRocket,
          features: [
            'Advanced campaign management',
            'Enhanced targeting options',
            'Real-time analytics',
            'Automated optimization'
          ]
        };
    }
  };

  const campaignInfo = getCampaignInfo(campaignType);

  return (
    <div className="main-panel w-100 p-4">
      <div className="content-wrapper">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-sm-12">
            {/* Header */}
            <div className="text-center mb-4">
              <Link 
                to="/client-area/whatsapp/broadcast-campaign" 
                className="btn btn-outline-primary mb-4 d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold"
                style={{
                  borderWidth: '2px',
                  textDecoration: 'none'
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Back to Campaign Types
              </Link>
              
              <div 
                className="shadow-lg p-5 rounded-4 text-white position-relative overflow-hidden mb-4"
                style={{
                  background: 'linear-gradient(135deg, #075E54 0%, #054b41 100%)',
                }}
              >
                <div className="mb-4">
                  <div 
                    className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center border"
                    style={{
                      width: '80px',
                      height: '80px',
                      background: 'rgba(255, 255, 255, 0.15)',
                      fontSize: '2rem',
                      backdropFilter: 'blur(10px)',
                      borderColor: 'rgba(255, 255, 255, 0.3)'
                    }}
                  >
                    <FontAwesomeIcon icon={campaignInfo.icon} />
                  </div>
                  
                  <h1 className="fw-bold mb-3" style={{ fontSize: '2.2rem' }}>
                    {campaignInfo.title}
                  </h1>
                  
                  <p className="opacity-90 max-w-600 mx-auto lead" style={{ fontSize: '1.05rem', lineHeight: '1.6' }}>
                    {campaignInfo.description}
                  </p>
                </div>
              </div>
            </div>

            {/* Coming Soon Badge */}
            <div className="text-center mb-5">
              <div 
                className="d-inline-flex align-items-center gap-2 text-white px-4 py-3 rounded-pill fw-bold shadow"
                style={{
                  background: 'linear-gradient(135deg, #075E54 0%, #054b41 100%)',
                  fontSize: '1.1rem'
                }}
              >
                <FontAwesomeIcon icon={faClock} />
                Coming Soon!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
